!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.chr = t());
}(this, function () {
  "use strict";

  return [{
    locale: "chr",
    pluralRuleFunction: function pluralRuleFunction(e, t) {
      return t ? "other" : 1 == e ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "ᎤᏕᏘᏴᏌᏗᏒᎢ",
        relative: {
          0: "ᎯᎠ ᏧᏕᏘᏴᏒᏘ",
          1: "ᎡᏘᏴᎢ",
          "-1": "ᎡᏘ ᏥᎨᏒ"
        },
        relativeTime: {
          future: {
            one: "ᎾᎿ {0} ᎤᏕᏘᏴᏌᏗᏒᎢ",
            other: "ᎾᎿ {0} ᎢᏧᏕᏘᏴᏌᏗᏒᎢ"
          },
          past: {
            one: "{0} ᎤᏕᏘᏴᏌᏗᏒᎢ ᏥᎨᏒ",
            other: "{0} ᎢᏧᏕᏘᏴᏌᏗᏒᎢ ᏥᎨᏒ"
          }
        }
      },
      month: {
        displayName: "ᎧᎸᎢ",
        relative: {
          0: "ᎯᎠ ᎧᎸᎢ",
          1: "ᏔᎵᏁ ᎧᎸᎢ",
          "-1": "ᎧᎸᎢ ᏥᎨᏒ"
        },
        relativeTime: {
          future: {
            one: "ᎾᎿ {0} ᎧᎸᎢ",
            other: "ᎾᎿ {0} ᏗᎧᎸᎢ"
          },
          past: {
            one: "ᎾᎿ {0} ᎧᎸᎢ ᏥᎨᏒ",
            other: "ᎾᎿ {0} ᏗᎧᎸᎢ ᏥᎨᏒ"
          }
        }
      },
      day: {
        displayName: "ᎢᎦ",
        relative: {
          0: "ᎪᎯ ᎢᎦ",
          1: "ᏌᎾᎴᎢ",
          "-1": "ᏒᎯ"
        },
        relativeTime: {
          future: {
            one: "ᎾᎿ {0} ᎢᎦ",
            other: "ᎾᎿ {0} ᎯᎸᏍᎩ ᏧᏒᎯᏛ"
          },
          past: {
            one: "{0} ᎢᎦ ᏥᎨᏒ",
            other: "{0} ᎯᎸᏍᎩ ᏧᏒᎯᏛ ᏥᎨᏒ"
          }
        }
      },
      hour: {
        displayName: "ᏑᏟᎶᏓ",
        relative: {
          0: "ᎯᎠ ᏑᏟᎶᏓ"
        },
        relativeTime: {
          future: {
            one: "ᎾᎿ {0} ᏑᏟᎶᏓ",
            other: "ᎾᎿ {0} ᎢᏳᏟᎶᏓ"
          },
          past: {
            one: "{0} ᏑᏟᎶᏓ ᏥᎨᏒ",
            other: "{0} ᎢᏳᏟᎶᏓ ᏥᎨᏒ"
          }
        }
      },
      minute: {
        displayName: "ᎢᏯᏔᏬᏍᏔᏅ",
        relative: {
          0: "ᎯᎠ ᎢᏯᏔᏬᏍᏔᏅ"
        },
        relativeTime: {
          future: {
            one: "ᎾᎿ {0} ᎢᏯᏔᏬᏍᏔᏅ",
            other: "ᎾᎿ {0} ᎢᏯᏔᏬᏍᏔᏅ"
          },
          past: {
            one: "ᎾᎿ {0} ᎢᏯᏔᏬᏍᏔᏅ ᏥᎨᏒ",
            other: "ᎾᎿ {0} ᎢᏯᏔᏬᏍᏔᏅ ᏥᎨᏒ"
          }
        }
      },
      second: {
        displayName: "ᎠᏎᏢ",
        relative: {
          0: "ᏃᏊ"
        },
        relativeTime: {
          future: {
            one: "ᎾᎿ {0} ᎠᏎᏢ",
            other: "ᎾᎿ {0} ᏓᏓᎾᏩᏍᎬ ᏥᎨᏒ"
          },
          past: {
            one: "{0} ᎠᏎᏢ ᏥᎨᏒ",
            other: "{0} ᏓᏓᎾᏩᏍᎬ ᏥᎨᏒ"
          }
        }
      }
    }
  }];
});